import { PersonRelationType } from '@dealstack/shared/lib/generated';

export enum RELATED_PEOPLE_FORM_FIELDS {
	relation_type = 'relation_type',
	person_ids = 'person_ids',
	create_legal_rep = 'create_legal_rep',
	custom_relation_type = 'custom_relation_type',
}

export interface RelatedPeopleFormValues {
	[RELATED_PEOPLE_FORM_FIELDS.relation_type]: PersonRelationType;
	[RELATED_PEOPLE_FORM_FIELDS.person_ids]: Array<string>;
	[RELATED_PEOPLE_FORM_FIELDS.create_legal_rep]?: boolean;
	/** Free-text role; only used when relation_type is OTHER. */
	[RELATED_PEOPLE_FORM_FIELDS.custom_relation_type]?: string;
}
